import { useContext, useLayoutEffect, useRef } from 'react';
import { ModuleNavigationContext } from './navigation/ModuleNavigation.jsx';
import { animateElements, entranceEase } from '../lib/motion.js';
import '../css/view-heading.css';

/** Whole modal titles are intentionally outside this component. */
export default function ViewHeading({ title, description, titleId, module = false, icon, children }) {
  const navigation = useContext(ModuleNavigationContext);
  const heading = useRef(null);
  const titleIcon = icon || navigation?.icon;
  const text = typeof title === 'string' ? title : null;
  useLayoutEffect(() => {
    if (!text) return undefined;
    const panel = heading.current.closest('.route-content');
    const localTab = panel && panel.dataset.motionPath === panel.dataset.routePath && panel.dataset.motionTitle !== text;
    const stopPanel = localTab ? animateElements([panel], [
      {opacity:1,transform:'translateY(2px)'},{opacity:1,transform:'none'},
    ], {duration:700,easing:'cubic-bezier(.4,0,.2,1)'}) : () => {};
    if (panel) { panel.dataset.motionPath = panel.dataset.routePath; panel.dataset.motionTitle = text; }
    const stopLetters = animateElements([...heading.current.querySelectorAll('.view-title-letter')], [
      { transform:'translateY(110%) rotate(4deg)' }, { transform:'translateY(0) rotate(0deg)' },
    ], index => ({ duration:900, delay:Math.min(index * 35,280), easing:entranceEase, fill:'backwards' }));
    const stopIcon = animateElements([...heading.current.querySelectorAll(':scope > .material-symbols-rounded')], [
      {opacity:0,transform:'translateY(16px)'}, {opacity:1,transform:'none'},
    ], {duration:900,easing:entranceEase,fill:'backwards'});
    return () => { stopPanel(); stopLetters(); stopIcon(); };
  }, [text, titleIcon]);
  return <div className={`${module ? 'module-header' : 'view-heading'} page-heading`}>
    <div className="page-heading-copy">
      <h2 ref={heading} id={titleId}>
        {text && titleIcon && <span className="material-symbols-rounded" aria-hidden="true">{titleIcon}</span>}
        {text ? <><span className="view-title-text" aria-hidden="true">{text.split(/(\s+)/).map((word,index) => /\s/.test(word) ? word :
          <span className="view-title-word" key={index}>{Array.from(word).map((letter,i) => <span className="view-title-letter" key={i}>{letter}</span>)}</span>)}</span>
          <span className="sr-only">{text}</span></> : title}
      </h2>
      {!module && description && <p className="view-heading-sub">{description}</p>}
    </div>{children}
  </div>;
}
